var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "observer",
    attrs: { tag: "div", slim: true },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var invalid = ref.invalid
            return [
              _c(
                "form",
                {
                  key: _vm._uid,
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit($event)
                    }
                  }
                },
                [
                  _c("el-error", { attrs: { error: _vm.error } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content",
                      class: _vm.contentClass,
                      attrs: { name: "default" }
                    },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  !_vm.hideFooter
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "form-footer flex items-center w-full mt-16"
                        },
                        [
                          _c("el-button", {
                            class: _vm.buttonClass,
                            attrs: {
                              loading: _vm.loading,
                              success: _vm.success,
                              loadingLabel: _vm.loadingText,
                              successLabel: _vm.successText,
                              defaultLabel: _vm.submitText,
                              disabled: invalid || _vm.disabled || _vm.success
                            }
                          }),
                          _vm._v(" "),
                          _vm.disclaimer
                            ? _c("span", {
                                staticClass:
                                  "text-blue opacity-70 text-14 lg:ml-24 ml-16",
                                domProps: { innerHTML: _vm._s(_vm.disclaimer) }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }